module.exports = __webpack_public_path__ + "static/media/cucumber.e7e9158b.png";